export class Coordinates {
    constructor() {
        this.Longitude = 0;
        this.Latitude = 0;
    }
}
export class CoordinatesWithSourceInfo {
    constructor() {
        this.Longitude = 0;
        this.Latitude = 0;
        this.IsNetworkBased = false;
    }
}
export var SetGeolocationResponseCode;
(function (SetGeolocationResponseCode) {
    SetGeolocationResponseCode[SetGeolocationResponseCode["OK"] = 0] = "OK";
    SetGeolocationResponseCode[SetGeolocationResponseCode["NoPermissions"] = 1] = "NoPermissions";
    SetGeolocationResponseCode[SetGeolocationResponseCode["UserIsNotLoggedIn"] = 2] = "UserIsNotLoggedIn";
    SetGeolocationResponseCode[SetGeolocationResponseCode["UnknownError"] = 3] = "UnknownError";
})(SetGeolocationResponseCode || (SetGeolocationResponseCode = {}));
//# sourceMappingURL=IGeolocationService.js.map